const Sun = ({dawn, sunrise, sunset, dusk}) => (
    <div className="sun">
        <span className="dawn">{`(${dawn})`}</span>
        <span className="sunrise">{sunrise}</span>
        <span className="icon-sun" />
        <span className="sunset">{sunset}</span>
        <span className="dusk">{`(${dusk})`}</span>
    </div>
);

export default Sun;
